import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Adminform from "./Component/Adminform";
import Header from "./Component/Header";
import Photoupload from "./Component/Photoupload";
import Update from "./Component/Update";
import Hostellist from "./Component/Hostellist";
import Newbutton from "./Component/Newbutton";
import Contact from "./Component/Contact";
import Dashboard from "./Component/Dashboard";
import Loginform from "./Component/Loginform";
import Otpform from "./Component/Otpform";
import Leads from "./Component/Leads";
import Footer from "./Component/Footer";
import Profile from "./Component/Profile";
import PaymentPage from "./Component/PaymentPage";
import { useState, useEffect } from "react";
import Cookies from "js-cookie";
import UpdateProfile from "./Component/UpdateProfile";
import CreateProfile from "./Component/CreateProfile";
import PrivacyPolicy from "./Component/PrivacyPolicy";
import TermsAndConditions from "./Component/TermsAndConditions";
import ScrollToTop from "./Component/ScrollToTop";

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isAndroidApp, setIsAndroidApp] = useState(false);
  
  useEffect(() => {
    const token = Cookies.get("token");
    setIsLoggedIn(!!token);
    
    // Check if user agent indicates Android app
    const userAgent = navigator.userAgent || "";
    const isAndroidApp = /MyHostelDuniyaApp/i.test(userAgent);
    setIsAndroidApp(isAndroidApp);
  }, []);
  // console.log(isLoggedIn);

  return (
    <>
      <div className="App" style={{ color: "#E4E4D8", minHeight: "100vh", display: "flex", flexDirection: "column" }}>
        <BrowserRouter>
          <ScrollToTop />
          <Header loggedIn={isLoggedIn} setLoggedIn={setIsLoggedIn} />

          <div style={{ flex: "1", display: "flex", flexDirection: "column" }}>
          <Routes>
            <Route
              path="/hostel/update/image/:hostelId"
              element={<Adminform />}
            ></Route>
            <Route path="/hostel/create" element={<Adminform />}></Route>
            <Route path="/Photoupload" element={<Photoupload />}></Route>
            <Route path="/hostel/update/:hostelId" element={<Update />}></Route>
            <Route path="/hostel/list" element={<Hostellist />}></Route>
            <Route path="/Newbutton" element={<Newbutton />}></Route>
            <Route path="/contact-us" element={<Contact />}></Route>
            <Route
              path="/"
              element={<Dashboard setIsLoggedIn={setIsLoggedIn} />}
            ></Route>
            <Route path="/login" element={<Loginform />}></Route>
            <Route path="/verifyOtp" element={<Otpform />}></Route>
            <Route path="/profile/create" element={<CreateProfile />}></Route>
            <Route path="/leads" element={<Leads />}></Route>
            <Route path="/profile" element={<Profile />}></Route>
            <Route path="/owner/add-money" element={<PaymentPage />}></Route>
            <Route
              path="/profile/update"
              element={
                <UpdateProfile
                  loggedIn={isLoggedIn}
                  setLoggedIn={setIsLoggedIn}
                />
              }
            ></Route>
            <Route path="/payment" element={<PaymentPage />}></Route>
            <Route path="/privacy-policy" element={<PrivacyPolicy />}></Route>
            <Route path="/terms-and-conditions" element={<TermsAndConditions />}></Route>
          </Routes>
          </div>
          {!isAndroidApp && <Footer />}
        </BrowserRouter>
      </div>
    </>
  );
}

export default App;
